import React from 'react';
import classes from './Footer.module.css';

const Footer = () => {
    return (
        <div className={classes.Footer}>
            <div className={classes.WiFiWrapper}>
                <div className={classes.Phone}>
                    <div className={classes.SocialItem}>
                        <div><i class="fas fa-wifi"></i></div>
                        <h4>
                            Κωδικός Wi Fi
                            <span>2463077170</span>
                        </h4>
                    </div>
                </div>
            </div>
            <div className={classes.PhoneWrapper}>
                <div className={classes.Phone}>
                    <div className={classes.SocialItem}>
                        <div><i class="fas fa-phone-alt"></i></div>
                        <h4>
                            Τηλέφωνο κρατήσεων του χώρου για τη διεξαγωγή εκδηλώσεων
                            <a href="tel:+302463077170">2463077170</a>
                        </h4>
                    </div>
                </div>
            </div>
            <div className={classes.FooterWrapper}>
                <div className={classes.SocialWrap}>
                    <div className={classes.SocialItem}>
                        <div><i class="fas fa-map-marker-alt"></i></div>
                        <div className={classes.Address}> 
                            <a href="https://www.google.com/maps/place/Kidcenter+Playground/@40.5425911,21.6898597,17z/data=!4m5!3m4!1s0x13577b76b501df5d:0x7b40f2d4710fe7a0!8m2!3d40.5427787!4d21.68869">
                                <address>3o km Πτολεμαΐδας - Φλώρινας <span>Έξοδος προς το ξενοδοχείο Ιωάννου</span></address>  
                            </a>  
                        </div>
                    </div>
                    <div className={classes.Social}>
                        <a href="https://www.facebook.com/KidcenterPlayground"><i class="fab fa-facebook-f"></i></a>
                        <a href="https://www.instagram.com/kidcenterplayground_/"><i class="fab fa-instagram"></i></a>
                    </div>                
                </div>                   
            </div> 

            <div className={classes.FooterLogo}>
                    <img src="./assets/images/logo_white.png" alt="kidcenter logo"/>
            </div>

            <div className={classes.Developer}>
                    <p>Web App Developed And Designed by</p>
                    <h6><a href="http://petrosgianniotis.gr/">Petros Gianniotis</a></h6>
                </div>         
        </div>
    )
}

export default Footer
